<script setup lang="ts">
import { RadioGroupIndicator, RadioGroupItem } from "reka-ui"

defineProps<{
  value: string
  label: string
  disabled?: boolean
}>()
</script>

<template>
  <RadioGroupItem
    :value="value"
    :disabled="disabled"
    class="radio-item"
    data-slot="radio-group-item"
  >
    <span
      class="radio-circle"
      aria-hidden="true"
    >
      <RadioGroupIndicator
        as="span"
        class="radio-dot"
      />
    </span>
    <span class="radio-label">{{ label }}</span>
  </RadioGroupItem>
</template>

<style scoped>
.radio-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  text-align: left;
}

.radio-item:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.radio-item:focus-visible {
  outline: 2px solid var(--ring);
  outline-offset: 2px;
  border-radius: 2px;
}

.radio-item[data-state="checked"] .radio-circle {
  border-color: var(--primary);
}

.radio-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid var(--border);
  flex-shrink: 0;
  transition: border-color 0.15s;
}

.radio-dot {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--primary);
}

.radio-label {
  font-size: 14px;
  color: var(--foreground);
  line-height: 1.4;
}
</style>
